<template>
  <div class="col-lg-3 col-md-5 product-bascet">
    <div class="row">
      <div class="col-sm-12 product-bascet-box">
        <div class="product-bascet-content">
          <div class="product-bascet-titr d-flex">
            <h6>سبد خرید شما از {{ business.title }}</h6>
            <i class="icon-shopping"></i>
            <span>{{ sumKala }}</span>
          </div>

          <div v-if="!$store.state.user.id" class="d-flex product-bascet-alert">
            <h6>برای خرید، لطفا وارد حساب کاربری خود شوید</h6>
          </div>
          <div v-else >
            <div v-if="buscard.length <= 0" class="d-flex product-bascet-alert">
              <h6>سبد خرید خالی است</h6>
            </div>
            <div
              v-for="(item, index) in buscard"
              :key="index"
              class="d-flex product-bascet-pro"
            >
              <div class="d-flex product-bascet-pro-title">
                <span>{{ item.title }}</span>
              </div>
              <div class="d-flex product-bascet-pro-conten">
                <div class="d-flex">
                  <span class="remove-shaping">
                    <i
                      @click.prevent="
                        removeCard(item.product_id, item.business_id)
                      "
                      class="icon-delete"
                    ></i>
                  </span>

                  <span class="price"> {{`${price(item.final_price)}` }}تومان</span>
                </div>

                <div class="d-flex count">
                  <i
                    @click.prevent="inCrease(item.product_id, item.business_id)"
                    class="icon-plus"
                  ></i>
                  <span> {{ item.quantity }}</span>
                  <i
                    @click.prevent="deCrease(item.product_id, item.business_id)"
                    class="icon-minus"
                  ></i>
                </div>
              </div>
              <div class="border col-12 mt-3"></div>
            </div>
          </div>

          <!-- <div class="border col-12"></div> -->

          <div class="product-bascet-detailAll d-flex">
            <div class="product-bascet-detail d-flex">
              <p class="detail-p">جمع مبلغ خالص</p>
              <p class="detail-p">مالیات({{ tax || 0 }} %)</p>
              <p class="detail-p">هزینه ارسال</p>
            </div>
            <div class="product-bascet-detail align-items d-flex">
              <p class="detail-p">{{ sumPricekama }}</p>
              <p class="detail-p">{{ Taxationkama }}</p>
              <p class="detail-p">رایگان</p>
            </div>
            <div class="product-bascet-detail d-flex">
              <p class="detail-p">تومان</p>
              <p class="detail-p">تومان</p>
              <p class="detail-p"></p>
            </div>
          </div>

          <div class="product-bascet-pay d-flex">
            <div class="product-bascet-detail d-flex">
              <p class="detail-p">جمع مبلغ خالص</p>
            </div>
            <div class="product-bascet-detail align-items d-flex">
              <p class="detail-p">{{ sumPurekama }}</p>
            </div>
            <div class="product-bascet-detail d-flex">
              <p class="detail-p">تومان</p>
            </div>
          </div>

          <div class="product-bascet-button d-flex">
            <button @click="checkFinal">بررسی نهایی</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import { mapState } from "vuex";

let business = {};

export default {
  name: "ShoppingBasket",
  props: ["data"],

  data() {
    return {
      buscard: [],
      lastread: [],
      tax: NaN,
      info: [],
    };
  },
  created() {
    this.readBusCard();
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    business() {
      if (localStorage.getItem("business")) {
        business = JSON.parse(localStorage.getItem("business"));
      }
      return business;
    },

    factorInfo() {
      let i;
      let sum = 0;
      for (i = 0; i < this.buscard.length; i++) {
        sum += +this.buscard[i].final_price * this.buscard[i].quantity;
      }
      let taxret = (this.tax * this.sumPrice) / 100;
      let info = {
        sumPrice: sum,
        tax: Math.ceil(taxret),
        pure: this.sumPrice + this.Taxation,
      };

      return info;
    },

    sumKala() {
      let i;
      for (i = 0; i < this.buscard.length; i++) {
        this.buscard[i];
      }
      return i || 0;
    },

    sumPrice() {
      let i;
      let sum = 0;
      for (i = 0; i < this.buscard.length; i++) {
        sum += +this.buscard[i].final_price * this.buscard[i].quantity;
      }
      return sum ;
    },

    sumPricekama(){
      let sumkama=this.sumPrice;
      let dis = new Intl.NumberFormat("ir-RL", {
        maximumSignificantDigits: 3,
      }).format(sumkama);
      return dis || 0;
    },

    Taxation() {
      let taxret = (this.tax * this.sumPrice) / 100;
      return Math.ceil(taxret) ;
    },

    Taxationkama(){
      let taxkama = this.Taxation;
      let tadis = new Intl.NumberFormat("ir-RL", {
        maximumSignificantDigits: 3,
      }).format(taxkama);
      return tadis || 0;

    },

    sumPure() {
      let pure = this.sumPrice + this.Taxation;
      return pure ;
    },

    sumPurekama(){
      let purekama = this.sumPure;
      let pudis = new Intl.NumberFormat( {
        maximumSignificantDigits: 3,
      }).format(purekama);
      console.log("nnnn:" , pudis)
      return pudis || 0;
    },
  },
  methods: {
    checkFinal() {
      this.$root.$emit("bv::show::modal", "check-final");
      this.$root.$emit("finalcheck", this.buscard, this.factorInfo);
    },

    async readBusCard() {
      await axios
        .get("cart/read_one.php", { params: { business_id: this.business.id } })
        .then((data) => {
          this.buscard = data.data;
          this.tax = Object.keys(data.data).length == 0 ? '' :data.data.pop().tax;
        });
    },

    price(final_price) {
      let dis = new Intl.NumberFormat("ir-RL", {
        maximumSignificantDigits: 3,
      }).format(final_price);
      return dis;
    },

    async removeCard(pid, bid) {
      // console.log("pid:" , pid);
      // console.log("bid:" , bid);
      let data = new FormData();
      data.append("pid", pid);
      data.append("bid", bid);
      data.append("action", "remove_from_cart");

      await axios.post("cart/user/remove-from-cart.php", data).then((data) => {
        console.log("data:", data.data);
        switch (data.data.msg) {
          case "success":
            this.$snotify.success("محصول مورد نظر حذف شد.");
            this.readBusCard();
            break;

          case "login_err":
            this.$snotify.warning("ابتدا وارد حساب کاربری خود شوید.");
            break;

          case "failure":
            this.$snotify.warning("خطا در حذف محصول");
            break;

          default:
            this.$snotify.warning("خطا در ارتباط با سرور");
        }
      });
    },

    async deCrease(pid, bid) {
      let data = new FormData();
      data.append("action", "decrease_qty");
      data.append("pid", pid);
      data.append("bid", bid);
      let findIndexProduct;

      await axios.post("cart/user/decrease-qty.php", data).then((data) => {
        switch (data.data.msg) {
          case "success":
            this.$snotify.success("محصول مورد نظر حذف شد.");
            this.readBusCard();
            findIndexProduct = this.buscard.findIndex(
              (el) => el.product_id == pid
            );

            if (this.buscard[findIndexProduct].quantity <= 1) {
              this.removeCard(pid, bid);
            }
            break;

          case "failure":
            this.$snotify.warning("خطا در حذف محصول");
            break;

          default:
            this.$snotify.warning("خطا در ارتباط با سرور");
        }
      });
    },

    async inCrease(pid, bid) {
      let data = new FormData();
      data.append("pid", pid);
      data.append("bid", bid);
      data.append("action", "increase_qty");
      await axios.post("cart/user/increase-qty.php", data).then((data) => {
        switch (data.data.msg) {
          case "success":
            this.$snotify.success("محصول مورد نظر اضافه شد.");
            this.readBusCard();
            break;

          case "failure":
            this.$snotify.warning("خطا در اضافه محصول");
            break;

          default:
            this.$snotify.warning("خطا در ارتباط با سرور");
        }
      });
    },
  },
  mounted() {
    this.$root.$on("addtocart", () => {
      this.readBusCard();
    });
  },

  watch: {
    user(val) {
      if (val.id) {
        this.readBusCard();
      }
    },
  },
};
</script>